export class ObjectUtils {
  static assign = Object.assign;
}
